import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Navbar from '../../../components/Navbar';
import DragupButton from '../../../components/DragupButton';
import Footer from '../../../components/Footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSolarPanel, faTools, faBroom, faSearch } from '@fortawesome/free-solid-svg-icons';
import './Photovoltaik.css';
import imgPanels from '../../../images/P20.webp';

function Photovoltaik() {
  return (
    <>
      <Helmet>
        <title>Photovoltaik | Elektro Thome</title>
        <link rel="canonical" href="https://energy-thome.com/leistungen/photovoltaik" />
      </Helmet>
      <DragupButton />
      <Navbar />

      {/* Main Content */}
      <div className="photovoltaik-container">
        {/* Hero Section */}
        <section className="photovoltaik-hero-section">
          <div className="photovoltaik-hero-text">
            <h1>Zukunftssichere Energielösungen mit Photovoltaik</h1>
            <p>
              Nutzen Sie die Kraft der Sonne mit unseren Photovoltaik-Komplettlösungen –
              von der Planung über die Installation bis zur Wartung. Wir bieten effiziente
              Systeme mit Power-Inverter und Batteriespeichern, um Ihre Energienutzung zu
              maximieren. Zusätzlich kümmern wir uns um die Pflege, Reinigung und
              Fehlerdiagnose der Solarmodule, unterstützt durch Drohnentechnologie, für
              optimale Leistung und Langlebigkeit.
            </p>
            <Link to="/contact" className="photovoltaik-cta-button">
              Kontaktieren Sie uns für eine Beratung
            </Link>
          </div>
          <div className="photovoltaik-hero-image">
            <img
              src={imgPanels}
              alt="Photovoltaik Installation"
            />
          </div>
        </section>

        {/* Services Section */}
        <section className="photovoltaik-services-section">
          <h2>Alles rund um Ihre Photovoltaik-Anlage</h2>
          <div className="photovoltaik-services-grid">
            <div className="photovoltaik-service-box">
              <FontAwesomeIcon icon={faSolarPanel} className="photovoltaik-service-icon" />
              <h3>Planung & Installation</h3>
              <p>
                Detaillierte Planung und professionelle Installation von Photovoltaiksystemen,
                abgestimmt auf Ihre Bedürfnisse.
              </p>
            </div>
            <div className="photovoltaik-service-box">
              <FontAwesomeIcon icon={faBroom} className="photovoltaik-service-icon" />
              <h3>Reinigung</h3>
              <p>
                Fachgerechte Reinigung der Solarmodule für maximale Leistung und Langlebigkeit,
                unterstützt durch Drohnentechnologie.
              </p>
            </div>
            <div className="photovoltaik-service-box">
              <FontAwesomeIcon icon={faSearch} className="photovoltaik-service-icon" />
              <h3>Fehlerdiagnose</h3>
              <p>
                Analyse und Fehlerdiagnose zur Sicherstellung einer optimalen Funktion Ihrer
                Solaranlage.
              </p>
            </div>
            <div className="photovoltaik-service-box">
              <FontAwesomeIcon icon={faTools} className="photovoltaik-service-icon" />
              <h3>Wartung</h3>
              <p>
                Regelmäßige Wartung und Überprüfung Ihrer Solaranlage, um eine langfristige
                und zuverlässige Energiegewinnung sicherzustellen.
              </p>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
}

export default Photovoltaik;
